const popup = (titleText, message, callback, event) => {
  const modal = document.createElement("div");
  modal.id = "alertModal";
  modal.classList.add("modal-back");

  const modalFrame = document.createElement("div");
  modalFrame.classList.add("modal-frame");

  if (event.clientX == "undefined" && event.clientY == "undefined" && event.clientX != 0 && event.clientY != 0) {
    modalFrame.style.left = event.clientX + "px";
    modalFrame.style.top = event.clientY + "px";
  } else {
    modalFrame.style.left = "50%";
    modalFrame.style.top = "50%";
  }

  const title = document.createElement("h4");
  title.classList.add("modal-title");
  title.append(titleText);

  const modalText = document.createElement("p");
  modalText.classList.add("modal-text");
  modalText.append(message);

  const btnYes = document.createElement("button");
  const btnNo = document.createElement("button");
  btnYes.append("Yes");
  btnNo.append("No");
  btnYes.classList.add("btn-yes");
  btnNo.classList.add("btn-no");
  btnYes.onclick = () => {
    callback();
    popupClose();
  };
  btnNo.onclick = () => {
    popupClose();
  };

  const btnDiv = document.createElement("div");
  btnDiv.classList.add("btn-div");

  btnDiv.append(btnYes, btnNo);

  modalFrame.append(title);
  modalFrame.append(modalText);
  modalFrame.append(btnDiv);
  modal.append(modalFrame);
  document.body.appendChild(modal);
};

const popupClose = () => {
  document.getElementById("alertModal").remove();
};

const flashAlert = (message, type = "success") => {
  try {
    const section = document.getElementsByTagName("section");
    const flashDiv = document.createElement("div");
    flashDiv.classList.add("flash-div");
    flashDiv.id = "flash-alert";

    switch (type) {
      case "success":
        flashDiv.classList.add("success");
        break;
      case "error":
        flashDiv.classList.add("error");
        break;
    }
    const flashText = document.createElement("p");
    flashText.append(message);

    flashDiv.append(flashText);
    flashDiv.classList.add("open");
    section[0].append(flashDiv);

    setTimeout(() => {
      try {
        document.getElementById("flash-alert").remove();
      } catch (error) {}
    }, 5000);
  } catch (error) {}
};

const dateFormat = (date) => {
  var d = new Date(date);
  var month = d.getMonth() + 1;
  var day = d.getDate();
  var year = d.getFullYear();
  if (month.length < 2) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return [year, month, day].join("-");
};

const makeInvalid = (e) => {
  e.target.classList.add("invalid");
};

export { popup, popupClose, flashAlert, dateFormat, makeInvalid };
